module.exports = "/_next/static/images/ReplayData-be14383f72debaf0c39936271cf31b19.webp";